App = App || {};

App.PasswordChange = (function ($, Vue) {
	"use strict";

	function init(target) {
		target = target || document.getElementById("pw-offcanvas");

		if (!target || target.dataset.mounted)
			return;

		target.dataset.mounted = true;
		var $modal = $(target);

		new Vue({
			el: target,
			data: {
				isSubmitting: false,
				isComplete: false,
				alertMessage: "",
				alertErrors: [],
				model: {
					id: "",
					oldPassword: "",
					newPassword: "",
					confirmPassword: ""
				}
			},
			methods: {
				validateConfirm: function () {
					var confirmEl = this.$el.querySelector("#pw-confirm");
					var matches = this.model.newPassword === this.model.confirmPassword;
					if (confirmEl && confirmEl.setCustomValidity) {
						confirmEl.setCustomValidity(matches ? "" : "Passwords must match.");
					}
				},
				clearState: function () {
					this.isSubmitting = false;
					this.isComplete = false;
					this.alertMessage = "";
					this.alertErrors = [];
					this.model.oldPassword = this.model.newPassword = this.model.confirmPassword = "";
					this.validateConfirm();
					this.$refs.form.classList.remove("was-validated");
				},
				submit: function () {
					this.validateConfirm();
					if (!this.$refs.form.checkValidity()) {
						this.$refs.form.classList.add("was-validated");
						return;
					}

					this.isSubmitting = true;
					this.alertMessage = "";
					this.alertErrors = [];
					this.isComplete = false;

					$.ajax({
						url: '/api/members/change-password',
						method: "POST",
						contentType: "application/json",
						data: JSON.stringify(this.model)
					})
						.done(response => {
							if (response && response.success) {
								this.isComplete = true;
								setTimeout(() => {
									$modal.modal("hide");
								}, 900);
							} else {
								this.alertMessage = (response && response.message) || "Password change failed.";
								var errs = (response && response.data && response.data.errors) || [];
								this.alertErrors = errs.map(e => e.description || e).filter(Boolean);
								this.$refs.form.classList.add("was-validated");
								this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
							}
						})
						.fail((jqXHR, status, err) => {
							this.alertMessage = "Password change failed.";
							this.$refs.form.classList.add("was-validated");
							this.$nextTick(() => this.$refs.topAlert && this.$refs.topAlert.focus && this.$refs.topAlert.focus({ preventScroll: true }));
						})
						.always(() => { this.isSubmitting = false; });
				}
			},
			mounted() {
				$(document)
					.off('show.bs.modal', $modal)
					.off('hidden.bs.modal', $modal);

				$(document).on('show.bs.modal', $modal, (event) => {
					const $trigger = $(event.relatedTarget);
					this.model.id = $trigger && $trigger.length ? String($trigger.data('id') || '') : this.model.id;
				});

				$(document).on('hidden.bs.modal', $modal, () => this.clearState());
			}
		});
	}

	return { init: init };
})(jQuery, Vue);

App.PasswordChange.init();
